<script setup lang="ts">
  import { ExternalUrlsEnum } from '@/assets/external-urls.enum';
  import { useI18 } from '@/plugins';

  const { t } = useI18();
  const { noRedirect } = defineProps<{
    noRedirect?: boolean;
  }>();
</script>

<template>
  <v-container>
    <v-row>
      <v-col lg="10" cols="12" class="mx-auto">
        <v-row class="mt-2 mt-sm-16">
          <v-col lg="6" sm="12" cols="12" class="mx-auto">
            <div
              class="d-flex justify-center flex-column gap-3 text-center align-center text-center"
            >
              <h1 class="text-grey text-h1 font-weight-bold">
                {{ t('error.404') }}
              </h1>
              <p class="text-primary text-h4 font-weight-medium">
                {{ t('error.oops') }}
              </p>
              <p
                class="text-body-2 text-grey-darken-3 mb-6"
                v-html="t('error.pageNotFound')"
              />
              <div v-if="!noRedirect" class="d-flex justify-center ga-10">
                <v-btn color="primary" to="/" max-width="220">
                  {{ t('error.backToHome') }}
                </v-btn>
                <slot name="action"> </slot>
              </div>
            </div>
          </v-col>
          <v-col lg="6" sm="12" cols="12">
            <v-img
              :src="ExternalUrlsEnum.images.defaultImages.notFound"
              alt="not-found"
              width="100%"
              height="300px"
              class="mt-n5"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<style lang="scss"></style>
